import '../../styles/components/inventory-status.scss';
import { createRoot } from 'react-dom/client';
import { APIProvider } from '@vis.gl/react-google-maps';
import { InventoryStatus } from '../react_components/InventoryStatus.js';

const rootElements = Array.from(document.querySelectorAll('[data-inventory-react-target]'));

// creates the roots to render the react components
if (rootElements.length > 0) {
  rootElements.forEach(rootEl => {
    const root = createRoot(rootEl);
    if (root) {
      root.render(
        <APIProvider apiKey={rootEl.dataset.inventoryReactTarget}>
          <InventoryStatus inventoryData={JSON.parse(document.querySelector('[data-inventory-data]').innerHTML)}/>
        </APIProvider>
      );
      rootEl._reactRootContainer = root;
    }
  });
}
